import { ExaminerQuestions } from '@/components/station/examiner-questions';
import { StationMarksPreview } from '@/components/station/preview-marks';
import { StationQuestionsPreview } from '@/components/station/preview-questions';
import { StationMarks } from '@/components/station/station-marks';
import { cn } from '@/core/ui';
import { useStation } from '@/store/station';
import Metadata from './metadata';

export const Right = () => {
  const preview = useStation.use.preview();
  return (
    <div className={cn('')}>
      <div className={cn({ hidden: preview })}>
        <Metadata />
        <br />
        <ExaminerQuestions showInfo={false} />
        <br />
        <StationMarks showInfo={false} />
      </div>
      {preview && (
        <>
          <StationQuestionsPreview />

          <StationMarksPreview />
        </>
      )}
    </div>
  );
};
